// ── IMAGE SLOTS (Scout Leader Ready) ────────────────────────────
// Hosted in the Impultienda store resources (Recursos).
const STORE = '0a479b1b-64ef-461f-96dc-52e3a3270768';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. Composited in code (no AI text): the Gamma Studio cover plus
 * real pages 4 and 8 on the iMac, and bonus covers with their titles typed in code. Pure white background.
 */
const IMAC = RES + '1792673718329_slr-mockup-imac-f05cb285.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** Real pages of the Gamma Studio book (9:16), same order as lookInside.captions: p.6, 29, 30, 31, 36, 39
 *  (only pages checked clean in QC). */
export const pageImages: string[] = [
  RES + '1792674299660_slr-pagina-06-plan-q3-008ac866.webp',
  RES + '1792674305578_slr-pagina-29-reunion-08-plan-aef6bfad.webp',
  RES + '1792674310287_slr-pagina-30-reunion-08-skill-c6e67667.webp',
  RES + '1792674315059_slr-pagina-31-reunion-08-cierre-4eb3d08a.webp',
  RES + '1792674319458_slr-pagina-36-reunion-10-estaciones-5d7422e9.webp',
  RES + '1792674323921_slr-pagina-39-planner-5b1217d0.webp',
];
/** 5 bonus covers (titles typed in code), in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  RES + '1792673723178_slr-bono-1-juegos-a8ce2400.webp',
  RES + '1792673726861_slr-bono-2-lluvia-b1fe905e.webp',
  RES + '1792673730508_slr-bono-3-camp-c3a6c195.webp',
  RES + '1792673734146_slr-bono-4-familia-4b84d6ea.webp',
  RES + '1792673737854_slr-bono-5-ceremonias-b2b22f20.webp',
];
